import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings, FiBell, FiClock, FiCheck, FiZap, FiMail } = FiIcons;

const RenewalAutomationSettings = ({ settings, onSave, templates }) => {
  const [localSettings, setLocalSettings] = useState(settings || {
    enabled: true,
    noticeDaysBefore: 60,
    followUpDaysAfter: 7,
    defaultTemplateId: 'ct1',
    autoEscalate: true
  });

  return (
    <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-xl animate-in slide-in-from-right duration-300">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-3 bg-indigo-100 text-indigo-600 rounded-2xl">
          <SafeIcon icon={FiZap} size={24} />
        </div>
        <div>
          <h3 className="text-xl font-black text-gray-900">Renewal Logic</h3>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Retention Automation Rules</p>
        </div>
      </div>

      <div className="space-y-6">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl border border-gray-100">
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiBell} className="text-indigo-500" />
            <div>
              <p className="text-sm font-black text-gray-900">Auto-Inquiry</p>
              <p className="text-[10px] text-gray-400 font-bold uppercase">Trigger first notice automatically</p>
            </div>
          </div>
          <button 
            onClick={() => setLocalSettings({...localSettings, enabled: !localSettings.enabled})}
            className={`w-12 h-6 rounded-full transition-colors relative ${localSettings.enabled ? 'bg-indigo-600' : 'bg-gray-300'}`}
          >
            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${localSettings.enabled ? 'left-7' : 'left-1'}`} />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block">Trigger Threshold</label>
            <div className="flex items-center gap-3">
              <div className="relative flex-1">
                <SafeIcon icon={FiClock} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
                <input 
                  type="number" 
                  value={localSettings.noticeDaysBefore}
                  onChange={(e) => setLocalSettings({...localSettings, noticeDaysBefore: e.target.value})}
                  className="w-full pl-9 p-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-black outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
              <span className="text-[10px] font-bold text-gray-400 uppercase whitespace-nowrap">Days Before End</span>
            </div>
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block">Notice Template</label>
            <div className="relative">
              <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
              <select 
                value={localSettings.defaultTemplateId}
                onChange={(e) => setLocalSettings({...localSettings, defaultTemplateId: e.target.value})}
                className="w-full pl-9 p-3 bg-gray-50 border border-gray-100 rounded-xl text-xs font-black outline-none appearance-none focus:ring-2 focus:ring-indigo-500"
              >
                {templates.map(t => (
                  <option key={t.id} value={t.id}>{t.title}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="p-4 bg-amber-50 rounded-2xl border border-amber-100">
          <p className="text-[10px] text-amber-700 font-black uppercase mb-1 flex items-center gap-1">
            <SafeIcon icon={FiSettings} size={10} /> Churn Mitigation
          </p>
          <p className="text-[10px] text-amber-600 font-medium leading-relaxed">
            The system will automatically log a "High Risk" alert in the access logs if no response is received within {localSettings.followUpDaysAfter} days of the first notice.
          </p>
        </div>

        <button 
          onClick={() => onSave(localSettings)}
          className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black text-[11px] uppercase tracking-widest hover:bg-indigo-700 transition shadow-lg shadow-indigo-100 flex items-center justify-center gap-2"
        >
          <SafeIcon icon={FiCheck} /> Commit Automation Rules
        </button>
      </div>
    </div>
  );
};

export default RenewalAutomationSettings;